import { IFactFindSectionConfig } from '@zeta-types';
import { create } from 'zustand';
import { IFactFindConfigStore } from './types';

export const useFactFindConfigStore = create<IFactFindConfigStore>((set) => ({
  factFindConfigDetails: {} as IFactFindSectionConfig,
  status: false,
  updateFactFindConfigDetails: (x: IFactFindSectionConfig, status: boolean) => set(() => ({ factFindConfigDetails: x, status: status })),
}));

export default useFactFindConfigStore;
